import { useNavigate } from 'react-router-dom';
import { ArrowRight, BedDouble, Building2, Car, Compass, Map, UserRound } from 'lucide-react';
import { useLang } from '../i18n';
import { Reveal } from './Reveal';
import { SectionHeader } from './SectionHeader';

const CATS = [
  { type: 'agency', icon: Map, nameKey: 'net.agency', descKey: 'net.agency.d' },
  { type: 'operator', icon: Building2, nameKey: 'net.operator', descKey: 'net.operator.d' },
  { type: 'guide', icon: UserRound, nameKey: 'net.guide', descKey: 'net.guide.d' },
  { type: 'accommodation', icon: BedDouble, nameKey: 'net.stay', descKey: 'net.stay.d' },
  { type: 'experience', icon: Compass, nameKey: 'net.exp', descKey: 'net.exp.d' },
  { type: 'transport', icon: Car, nameKey: 'net.transfers', descKey: 'net.transfers.d' },
];

export const LocalNetwork = () => {
  const { t } = useLang();
  const navigate = useNavigate();

  return (
    <section data-testid="local-network-section" className="bg-eco-deep py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-5 md:px-8">
        <SectionHeader
          align="center"
          dark
          eyebrow={t('net.kicker')}
          title={t('net.title')}
          text={t('net.desc')}
        />

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {CATS.map((c, i) => (
            <Reveal key={c.type} delay={i * 0.08} className="h-full">
              <button
                data-testid={`network-category-${c.type}`}
                onClick={() => navigate(`/partners?type=${c.type}`)}
                className="group flex h-full w-full flex-col rounded-2xl border border-white/10 bg-white/5 p-6 text-left transition-[transform,background-color,border-color] duration-200 hover:-translate-y-0.5 hover:border-eco-gold/50 hover:bg-white/10"
              >
                <span className="grid h-12 w-12 place-items-center rounded-2xl bg-eco-gold/15 ring-1 ring-eco-gold/30">
                  <c.icon size={20} className="text-eco-gold" />
                </span>
                <h3 className="mt-5 text-lg leading-[1.3] font-semibold tracking-[-0.015em] text-white">{t(c.nameKey)}</h3>
                <p className="eco-secondary mt-2 flex-1 text-white/55">{t(c.descKey)}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-eco-gold">
                  {t('nav.explore')}
                  <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
